// src/plugins/vuetify.js

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {};

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#000000', // Your custom primary color
        secondary: '#1A7D6D', // Your custom secondary color
        accent: '#0DD7B5', // Your custom accent color
        error: '#FF5252', // Your custom error color,
        background: '#ffffff',
      },
      dark: {
        primary: '#ffffff', // Your custom primary color for dark mode
        secondary: '#0DD7B5', // Your custom secondary color for dark mode
        accent: '#1A7D6D', // Your custom accent color for dark mode
        error: '#FFA726', // Your custom error color for dark mode
        background: '#000000',
      },
    },
  },
});
